import React from 'react';
import type { FC, PropsWithChildren } from 'react';

import type { TMenuListButton } from './models';

export const MenuItemButton: FC<PropsWithChildren<TMenuListButton>> = ({
    Button,
    buttonView,
    children,
    link,
}) => {
    return (
        <Button href={link} size="xxs" styler={{ marginTop: 12 }} view={buttonView}>
            {children}
        </Button>
    );
};
